import { ReactComponent as CloseIconSVG } from '@/assets/icons/CloseIcon.svg';
import { SVGProps } from 'react';

const CloseIcon = (props: SVGProps<SVGSVGElement>) => <CloseIconSVG {...props} />;

export default CloseIcon;
